<div class="workflow-form" c-toggle="showDetails" c-toggle-options="{type: 'fade'}">
    <div id="no-access" ng-if="showNoAccess">
        <i class="fa fa-exclamation-triangle"></i>
        <p>{{'no-access'|translate}}</p>
    </div>
    <c-auto-form config="workflowFormCtrl.autoFormConfig"></c-auto-form>
</div>